/* eslint-disable no-shadow */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Label } from 'reactstrap';
import AddBoxNumber from './AddBoxNumber';
import { addNumberModalCancel, cancelAddNumber, editNumberCancel } from '../../../actions/Numbers';
import { getGateways } from '../../../actions/Provisioning';
import EditBoxNumber from './EditBoxNumber';
import Toggle from '../../Toggle';
import EditBoxAtaNumber from './EditBoxAtaNumber';
import WarningModal from '../../WarningModal';
import { toast } from 'react-toastify';

const AddBoxNumberModal = ({
  isOpen,
  onConfirm,
  onCancel,
  boxDetails,
  cancelAddNumber,
  editNumberCancel,
  selectRoute,
  gateways,
  onEditPropertyKeyPress,
  vmail,
  port,
  props
}) => {
  const [toggleState, setToggleState] = useState(false);
  const [confirmation, setConfirmation] = useState(false);

  const handleToggle = () => {
    setToggleState(!toggleState);
    cancelAddNumber();
    editNumberCancel();
  };
  const handleConfirm = () => {
    const { editedNumber } = props;
    const isRingDown = editedNumber?.type === 'ringDown';
    const hasNoForwardUris = !editedNumber?.forwardUris?.length;
    if (isRingDown && hasNoForwardUris) {
      return toast.error('Ring down number is required');
    }

    setConfirmation(true);
  };

  const handleConfirmAtaWarning = () => {
    setConfirmation(false);
    onConfirm(!toggleState);
  }

  return (
    <Modal size="lg" style={{ maxWidth: '900px' }} isOpen={isOpen}>
      <ModalHeader className="edit-number-port">
        Add new Number
        <Row hidden={vmail}>
          <Label for="enabled" sm={4}>
            Assign New Number
          </Label>
          <Col sm={3} style={{ marginTop: '8px' }}>
            <Toggle value={toggleState} onToggle={() => handleToggle()} />
          </Col>
          <Label for="enabled" sm={4}>
            Port Number
          </Label>
        </Row>
      </ModalHeader>
      <ModalBody>
        {toggleState ? (
          <AddBoxNumber toggleMode={toggleState} boxDetails={boxDetails} />
        ) : (
          <EditBoxNumber
            vmail={vmail}
            toggleMode={toggleState}
            selectRoute={selectRoute}
            gateways={gateways}
            boxDetails={boxDetails}
            onEditPropertyKeyPress={onEditPropertyKeyPress}
          />
        )}
      </ModalBody>
      <ModalFooter>
        <Button outline color="secondary" onClick={onCancel} id="port-cancel-btn">
          Cancel
        </Button>
        <Button
          color="primary"
          // onClick={() => setConfirmation(true)}
          onClick={() => handleConfirm(true)}
          id="port-save-btn"
        >
          Save
        </Button>
        <WarningModal
          isOpen={confirmation}
          onConfirm={handleConfirmAtaWarning}
          title="Warning"
          onCancel={() => setConfirmation(false)}
          body={
            'The ATA needs to be rebooted to configure the port and the affected ports will be offline for 3 minutes. Are you sure you want to proceed?'
          }
        />
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = state => ({
  company: state.UIState.numbers.addNumber.company,
  type: state.UIState.numbers.addNumber.type,
});

const mapDispatchToProps = dispatch => ({
  addNumberModalCancel: () => dispatch(addNumberModalCancel()),
  getGateways: token => dispatch(getGateways(token)),
  cancelAddNumber: () => dispatch(cancelAddNumber()),
  editNumberCancel: () => dispatch(editNumberCancel()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddBoxNumberModal);
